<template lang="pug">
  v-card
    v-toolbar.elevation-0(height="45" color="gray")
      v-toolbar-title
        h1.subheading Lead Status
    div#lead-pie
</template>

<script>
import dashbaordService from '../../service.js'
export default {
  mounted() {
    this.getAllLeadCount()
  },
  methods: {
    getAllLeadCount() {
      return dashbaordService.getAllLeadCount()
      .then(data => {
        if(data){
          var newData = []
          data.data.LeadStatusCount.forEach(row =>{
            newData.push([row.selector, row.total])
          })

          var HighChartPie = $('#lead-pie')
          if (HighChartPie.length) {

            HighChartPie.highcharts({
                credits: false, // Disable HighCharts logo
                colors: ['#4a89dc', '#3bafda', '#8A1B1D'],// Set Colors
                chart: {
                    type: 'column'
                },
                title: {
                    text: null
                },
                tooltip: {
                    pointFormat: '{series.name}: <b>{point.y:.1f}</b>'
                },
                plotOptions: {
                    pie: {
                      allowPointSelect: true,
                      cursor: 'pointer',
                      dataLabels: {
                          enabled: false
                      },
                      showInLegend: true
                    }
                },
                xAxis: {
                    type: 'category',
                    labels: {
                        rotation: -45,
                        style: {
                            fontSize: '13px',
                            fontFamily: 'Verdana, sans-serif'
                        }
                    }
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: 'Leads Count'
                    }
                },
                legend: {
                    enabled: false,

                },
                series: [{
                    name: 'Status',
                    data: newData,
                    dataLabels: {
                        enabled: true,
                        rotation: -90,
                        color: '#FFFFFF',
                        align: 'right',
                        format: '{point.y:.1f}', // one decimal
                        y: 10, // 10 pixels down from the top
                        style: {
                            fontSize: '13px',
                            fontFamily: 'Verdana, sans-serif'
                        }
                    }
                }]
            })
          }
        }
      })
    }
  }
}
</script>
